/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Test coffee script

class CoffeeTest {
  constructor() {}

  testMe() {
    return alert("Hello, World!");
  }
}

window.CoffeeTest = CoffeeTest;
